import * as React from 'react';
import * as footerStyles from '../styles/footer.module.css';

const Footer = () => (
  <footer className={`container-fluid text-center ${footerStyles.myFooter}`}>
    <span>
      TechBoss ©
      {' '}
      {' '}
      {' '}
      {new Date().getFullYear()}
    </span>
    <a
      href="https://www.facebook.com/TechBoss-104553298548814/"
      target="_blank"
      rel="noopener noreferrer"
    >
      FACEBOOK
    </a>
    <a href="https://wa.me/6596474920" target="_blank" rel="noopener noreferrer">WHATSAPP</a>
    <a href="tel:+65 9647 4920" target="_blank" rel="noopener noreferrer">PHONE</a>
    <a href="#" target="_blank" rel="noopener noreferrer">EMAIL</a>
    <a href="#" target="_blank" rel="noopener noreferrer">ADDRESS</a>
  </footer>
);

export default Footer;
